export default "__VITE_ASSET__CqNda8MY__"